import React, { useState, useEffect } from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials as defaultTestimonials } from '../data/mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState(defaultTestimonials);
  const [header, setHeader] = useState({
    label: "Testimonials",
    title: "What Our Clients Say",
    description: "Real results from real businesses we've helped transform"
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [testimonialsRes, headerRes] = await Promise.all([
          axios.get(`${API}/content/testimonials`),
          axios.get(`${API}/content/section-headers/testimonials`)
        ]);
        if (testimonialsRes.data && testimonialsRes.data.length > 0) {
          setTestimonials(testimonialsRes.data.filter(item => item.visible !== false));
        }
        if (headerRes.data) {
          setHeader(headerRes.data);
        }
      } catch (error) {
        console.log('Using default testimonials');
      }
    };
    fetchData();
  }, []);

  return (
    <section className="py-8 bg-navy-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-gold-400/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-8">
          <span className="inline-block text-gold-400 font-semibold text-sm tracking-wider uppercase mb-4">
            {header.label}
          </span>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-6">
            {header.title}
          </h2>
          <p className="text-base text-white/70 leading-relaxed">
            {header.description}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="panel-flair-dark group relative p-8 bg-white/5 backdrop-blur-sm rounded-2xl border-2 border-white/10 hover:border-gold-400/60 hover:bg-white/10 overflow-hidden transition-all duration-300"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8">
                <div className="w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center">
                  <Quote className="w-5 h-5 text-navy-900" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-6 mt-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-gold-400 fill-gold-400" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-white/90 leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="border-t border-white/10 pt-6">
                <div className="font-semibold text-white">{testimonial.author}</div>
                <div className="text-gold-400 text-sm">{testimonial.company}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
